// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".effectStickySections{\n    position: sticky;\n    z-index: 1000;\n    top: 80px;\n}\n\n\n\ntable {\n    width: 100%;\n    margin-bottom: 1rem;\n    color: #212529;\n    border-collapse: collapse;\n}\n\nthead{\n    font-weight: bold;\n    color: #fff;\n    background-color: #343a40;\n    border-color: #454d55;\n    text-align: center;\n    \n}\n\ntbody tr {\n    border-bottom: 1px solid #ffffff;\n}\n", ""]);
// Exports
module.exports = exports;
